import { createContext, useContext } from 'react';
import { SidebarContext } from '../sidebar';
export var NavigationCollapseContext = SidebarContext;
export var NavigationOrientationContext = createContext('horizontal');
export var NavigationTierContext = createContext(0);
export var NavigationTransparencyContext = createContext(false);
/**
 *
 * @returns {Object} The current navigation context.
 *   - `isCollapsedArea`: If `true`, elements rendered inside this portion of the navigation
 *                        should display a collapsed version (if applicable).
 *                        This value is `true` for collapsed vertical navigation
 *                        and for tier 1 in tiered vertical navigation.
 *   - `isTransparent`: If `true`, the navigation component has a transparent background.
 *   - `orientation`: The directional orientation of the navigation element.
 *   - `tier`: The tier of this portion of the navigation. If `0`, the navigation is not tiered.
 */
export var useNavigationContext = function () {
    var state = useContext(NavigationCollapseContext).state;
    var orientation = useContext(NavigationOrientationContext);
    var tier = useContext(NavigationTierContext);
    var isTransparent = useContext(NavigationTransparencyContext);
    return {
        isCollapsedArea: orientation === 'vertical' && (state === 'collapsed' || tier === 1),
        isTransparent: isTransparent,
        orientation: orientation,
        tier: tier,
    };
};
useNavigationContext.displayName = 'useNavigationContext';
